import { IList, IRecord } from 'annotation-tools/utils';
import { RawRectangleType } from '../common/raw-rectangle';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  ImageInfoAPIRawRequestBodyType,
  ImageInfoAPIRequestBodyType
} from './api-request-body';

export type ImageInfoAPIRawSuccessResponseType = {
  id: number;
  name: string;
  file: string;
  width: number;
  height: number;
  crop_option: RawRectangleType;
  annotation_count: number;
  is_annotated: boolean;
};

export type ImageInfoAPIRawValidationErrorType = APIRawValidationErrorType<
  ImageInfoAPIRawRequestBodyType
>;

export type ImageInfoAPIValidationErrorType = APIValidationErrorType<
  ImageInfoAPIRequestBodyType
>;

export type IImageInfoAPIValidationErrorType = IAPIValidationErrorType<
  ImageInfoAPIRequestBodyType
>;

export const IImageInfoAPIValidationErrorFactory = IRecord<
  ImageInfoAPIValidationErrorType
>({
  cropRect: IList<string>(),
  fileGuid: IList<string>()
});
